import { hexToRgba } from '@coreui/coreui-pro/dist/js/coreui-utilities';
import axios from 'axios';
import moment from 'moment';
import React, { Component } from 'react';
import { Bar } from 'react-chartjs-2';
import { connect } from 'react-redux';
import { setAlarm } from '../../../../redux/actions/general';
import { CsvExportFromApiButton, HorizontalSeparator, Spinner } from '../../../common';
import ReactDOMServer from 'react-dom/server';
import { Tooltip as ReactTooltip } from 'react-tooltip/dist/react-tooltip.umd';

import { CardTitle, Col, Row } from 'reactstrap';
import { filtersChanged, timespanOrIntervalChanged } from '../../../../redux/selectors/comparing';

import 'spinkit/css/spinkit.css';

import { PropTypes } from 'prop-types';
import storePropTypes from './../../../../redux/store/propTypes';

import { WEBRTC_VIEW } from '../../../../constants/general';
import {
   AlignedIconContainer,
   CenteredMsgShowing,
   ChartWrapper,
   DescriptionLink,
   HeightSetContainer,
   SetChartHeight,
   SimpleFlexItem,
   SimpleFlexRow,
   StyledButton,
   TwoSideFlexContainer,
   WidgetBodyContainer,
   WidgetContainer,
   WidgetHeaderContainer,
} from '../../../../styledComponents/styledComponents';
import { barChartZoomOptions } from './../../../../constants/chartjs';
import ComponentTools from './../../../../util/ComponentTools';

import { DefaultBlue, DefaultGrey } from '../../../../constants/colors';
import { getUnifiedErrorObject } from '../../../../util/ErrorUnifier';
import { STATUS_ERROR_CODES } from '../../../zoom/ZoomConstants';
import ZoomHint from '../../../zoom/ZoomHint';
import Modal from '../../../zoom/templates/DefaultTemplate';
import { WEBRTC_SETTINGS } from '../../../zoom/widgetSettings/WebrtcView';

// Chart options
const chartOptions = barChartZoomOptions();

// --- Version 5 Error Codes ---
const errorCodeMapV5 = new Map();

// General Errors
errorCodeMapV5.set('1000', 'expected');
errorCodeMapV5.set('1001', 'expected');
errorCodeMapV5.set('1002', 'expected');
errorCodeMapV5.set('1003', 'expected');
errorCodeMapV5.set('1004', 'expected');
errorCodeMapV5.set('1005', 'expected');
errorCodeMapV5.set('1006', 'expected');

// Request Errors
errorCodeMapV5.set('2000', 'expected');

// Critical Errors
errorCodeMapV5.set('7000', 'critical');
errorCodeMapV5.set('9000', 'critical');
errorCodeMapV5.set('106001', 'critical');
errorCodeMapV5.set('109000', 'critical');

// WebSocket Errors
errorCodeMapV5.set('3000', 'notCritical');
errorCodeMapV5.set('3001', 'notCritical');
errorCodeMapV5.set('3002', 'notCritical');
errorCodeMapV5.set('3003', 'notCritical');
errorCodeMapV5.set('3004', 'notCritical');

// Session Errors
errorCodeMapV5.set('4000', 'notCritical');
errorCodeMapV5.set('4001', 'notCritical');
errorCodeMapV5.set('4002', 'notCritical');
errorCodeMapV5.set('4003', 'notCritical');

// Broadcast Errors
errorCodeMapV5.set('5000', 'notCritical');
errorCodeMapV5.set('5001', 'notCritical');
errorCodeMapV5.set('5002', 'notCritical');
errorCodeMapV5.set('5003', 'notCritical');

// WebRTC Errors
errorCodeMapV5.set('6000', 'notCritical');
errorCodeMapV5.set('6001', 'notCritical');
errorCodeMapV5.set('6002', 'notCritical');
errorCodeMapV5.set('6003', 'notCritical');
errorCodeMapV5.set('6004', 'notCritical');
errorCodeMapV5.set('6005', 'notCritical');
errorCodeMapV5.set('6006', 'notCritical');
errorCodeMapV5.set('6008', 'notCritical');

// General Errors
errorCodeMapV5.set('101001', 'notCritical');
errorCodeMapV5.set('101002', 'notCritical');
errorCodeMapV5.set('101003', 'notCritical');

// Access Errors
errorCodeMapV5.set('102001', 'notCritical');

// Authentication Errors
errorCodeMapV5.set('103000', 'notCritical');
errorCodeMapV5.set('103001', 'notCritical');
errorCodeMapV5.set('103002', 'notCritical');
errorCodeMapV5.set('103004', 'notCritical');

// Bintu Errors
errorCodeMapV5.set('104001', 'notCritical');
errorCodeMapV5.set('104002', 'notCritical');
errorCodeMapV5.set('104003', 'notCritical');

// Session Errors
errorCodeMapV5.set('107001', 'notCritical');
errorCodeMapV5.set('107002', 'notCritical');

// --- Version 6 Error Codes ---
const errorCodeMapV6 = new Map();
// Stream/Request Errors
errorCodeMapV6.set('2001', 'expected');
errorCodeMapV6.set('2002', 'notCritical');
errorCodeMapV6.set('2003', 'critical');

// General Errors
errorCodeMapV6.set('4000', 'notCritical');
errorCodeMapV6.set('4001', 'notCritical');
errorCodeMapV6.set('4002', 'notCritical');
errorCodeMapV6.set('4003', 'critical');
errorCodeMapV6.set('4004', 'notCritical');

// Broadcast Errors
errorCodeMapV6.set('5001', 'notCritical');
errorCodeMapV6.set('5002', 'expected');
errorCodeMapV6.set('5003', 'critical');
errorCodeMapV6.set('5004', 'critical');
errorCodeMapV6.set('5005', 'critical');
errorCodeMapV6.set('5006', 'critical');

// WebRTC/Device Errors
errorCodeMapV6.set('6001', 'critical');
errorCodeMapV6.set('6002', 'notCritical');
errorCodeMapV6.set('6003', 'critical');

// Validation Errors
errorCodeMapV6.set('7000', 'notCritical');

// Metrics Errors
errorCodeMapV6.set('8001', 'expected');
errorCodeMapV6.set('8002', 'notCritical');
errorCodeMapV6.set('8003', 'expected');
errorCodeMapV6.set('8004', 'expected');

// Server Errors
errorCodeMapV6.set('10001', 'critical');
errorCodeMapV6.set('10002', 'critical');
errorCodeMapV6.set('10003', 'critical');

// Client Errors
errorCodeMapV6.set('11001', 'notCritical');
errorCodeMapV6.set('11002', 'notCritical');
errorCodeMapV6.set('11003', 'notCritical');
errorCodeMapV6.set('11004', 'expected');

const mapStateToProps = (state) => {
   return state.general;
};

const mapDispatchToProps = { setAlarm };

// Utility functions
function getNewDataSet(label, color, errorStatus) {
   return {
      total: 0,
      label: 'Code ' + label,
      backgroundColor: hexToRgba(color, 10),
      borderColor: color,
      borderWidth: 1,
      data: [],
      hidden: false,
      status: errorStatus,
   };
}

function getTrafficLightColor(errorStatus) {
   if (errorStatus === 'expected') return '#20c997'; // green
   if (errorStatus === 'notCritical') return '#f8cb00'; // yellow
   return '#e83e8c'; // red
}

let requestForData = false;

class Errors extends Component {
   constructor(props) {
      super(props);
      this.state = {
         loading: false,
         noDataV5: false,
         noDataV6: false,
         activeTab: '6',
         chartV5: { type: 'bar', labels: [], datasets: [] },
         chartV6: { type: 'bar', labels: [], datasets: [] },
         modal: {
            toggleShow: false,
            timespansPerIndex: [{ start: moment.utc(), end: moment.utc() }],
            chosenIndex: 0,
            selectedError: '',
         },
         error: '',
         url: '',
         header: {},
         cancelToken: null,
      };
      this.chartRefV5 = React.createRef();
      this.chartRefV6 = React.createRef();
   }

   // Helper to determine active tab based on data availability
   determineActiveTab(v5HasData, v6HasData) {
      if (this.state.activeTab === '5') {
         return v5HasData ? '5' : v6HasData ? '6' : '5';
      } else {
         return v6HasData ? '6' : v5HasData ? '5' : '6';
      }
   }

   getData(timespan, filter, cancelToken) {
      // Always clean up any previous cancel token
      if (this.state.cancelToken) {
         this.state.cancelToken.cancel('New request initiated');
      }

      this.setState({
         loading: true,
         noDataV5: false,
         noDataV6: false,
         error: '',
         // Store new cancel token
         cancelToken: cancelToken,
      });

      const headerObj = ComponentTools.getHttpHeader(filter);
      const urlFilterQuery = ComponentTools.getFilterQueryParams(filter, WEBRTC_VIEW);

      const updatedV5 = { type: 'bar', labels: [], datasets: [] };
      const updatedV6 = { type: 'bar', labels: [], datasets: [] };

      const labels = [];
      const timespansPerIndex = [];

      ComponentTools.setBarChartLabels(updatedV5, labels, timespan, this.props.settings.weekType, timespansPerIndex);
      ComponentTools.setBarChartLabels(updatedV6, labels, timespan, this.props.settings.weekType, timespansPerIndex);

      const url = `/v2/webrtc/errorcodes/timeseries?from=${timespan.gte.format()}&to=${timespan.lt.format()}&interval=${
         timespan.interval
      }${urlFilterQuery}`;

      axios
         .get(url, {
            headers: headerObj,
            cancelToken: cancelToken.token,
         })
         .then((response) => {
            if (response.status !== 204) {
               const buckets = response.data.aggregations.histogram.buckets;

               // Create a Map: version => errorCode => dataset
               const datasetsV5 = new Map();
               const datasetsV6 = new Map();

               // Pre-create empty arrays for each timestamp
               buckets.forEach(() => {
                  for (const ds of datasetsV5.values()) ds.data.push(0);
                  for (const ds of datasetsV6.values()) ds.data.push(0);
               });

               buckets.forEach((bucket, bucketIndex) => {
                  const clientVersions = bucket.clientVersions?.buckets || [];

                  clientVersions.forEach((clientVersionBucket) => {
                     const version = clientVersionBucket.key;

                     const isV5 = version.startsWith('5');
                     const isV6 = version.startsWith('6');
                     if (!isV5 && !isV6) return;

                     const errors = clientVersionBucket.errors.buckets || [];

                     errors.forEach((errorCodeBucket) => {
                        const code = String(errorCodeBucket.key);
                        const count = errorCodeBucket.doc_count;

                        const map = isV5 ? datasetsV5 : datasetsV6;
                        const status = isV5
                           ? errorCodeMapV5.get(code) || 'notCritical'
                           : errorCodeMapV6.get(code) || 'notCritical';

                        if (!map.has(code)) {
                           const color = getTrafficLightColor(status);

                           const ds = getNewDataSet(code, color, status);
                           ds.data = Array(buckets.length).fill(0); // Fill with zeros
                           map.set(code, ds);
                        }

                        map.get(code).data[bucketIndex] += count; // Fill with correct timestamp
                     });
                  });
               });

               // Convert Maps to arrays
               updatedV5.datasets = [...datasetsV5.values()];
               updatedV6.datasets = [...datasetsV6.values()];

               // Sort datasets by status
               const order = { expected: 0, notCritical: 1, critical: 2 };
               const sortByStatus = (a, b) => order[a.status] - order[b.status];
               updatedV5.datasets.sort(sortByStatus);
               updatedV6.datasets.sort(sortByStatus);
            }

            // Determine which version has data and set activeTab accordingly
            const v5HasData = updatedV5.datasets.length > 0;
            const v6HasData = updatedV6.datasets.length > 0;

            // If current activeTab has no data but the other does, switch tabs
            const newActiveTab = this.determineActiveTab(v5HasData, v6HasData);

            this.setState({
               chartV5: updatedV5,
               chartV6: updatedV6,
               loading: false,
               noDataV5: updatedV5.datasets.length === 0,
               noDataV6: updatedV6.datasets.length === 0,
               activeTab: newActiveTab,
               modal: { ...this.state.modal, timespansPerIndex },
               url,
               header: headerObj,
               cancelToken,
            });
         })
         .catch((error) => {
            if (error instanceof axios.Cancel) {
               return;
            }
            const errorObject = getUnifiedErrorObject(error);
            this.props.setAlarm('danger', errorObject);

            if (process.env.NODE_ENV === 'development') {
               console.error('error :', error);
            }

            this.setState({
               chartV5: updatedV5,
               chartV6: updatedV6,
               loading: false,
               error: errorObject.message,
            });
         });
   }
   componentWillUnmount() {
      // Destroy chart instances to prevent memory leaks
      if (this.chartRefV5.current && this.chartRefV5.current.chartInstance) {
         this.chartRefV5.current.chartInstance.destroy();
      }
      if (this.chartRefV6.current && this.chartRefV6.current.chartInstance) {
         this.chartRefV6.current.chartInstance.destroy();
      }
   }

   componentDidMount() {
      requestForData = true;

      // Set up chart click handler
      chartOptions.onClick = this.handleChartClick;
   }

   componentWillReceiveProps(nextProps, nextContext) {
      if (timespanOrIntervalChanged(this.props, nextProps) || filtersChanged(this.props, nextProps) || requestForData) {
         // Cancel any existing requests to prevent race conditions
         if (this.state.cancelToken) {
            this.state.cancelToken.cancel('New request initiated');
         }

         requestForData = false;
         this.getData(nextProps.timespan, nextProps.filter, nextProps.cancelToken);
      }
   }
   handleChartClick = (event) => {
      // Use the correct ref depending on the active tab
      const chartRef = this.state.activeTab === '5' ? this.chartRefV5 : this.chartRefV6;

      if (!chartRef.current || !chartRef.current.chartInstance) return;

      const activePoint = chartRef.current.chartInstance.getElementAtEvent(event)[0];
      if (!activePoint) return;

      const datasetIndex = activePoint._datasetIndex;
      const data = activePoint._chart.data;
      const clickedLabel = data.datasets[datasetIndex].label;
      const index = activePoint._index;

      this.setState({
         modal: {
            ...this.state.modal,
            chosenIndex: index,
            selectedError: clickedLabel.substring(5),
            toggleShow: true,
            version: this.state.activeTab, // Add version info
         },
      });
   };

   toggleTab = (tab) => {
      if (this.state.activeTab !== tab) {
         this.setState({ activeTab: tab }, () => {
            // Force update of the visible chart
            const chartRef = tab === '5' ? this.chartRefV5 : this.chartRefV6;
            const hasNoData = tab === '5' ? this.state.noDataV5 : this.state.noDataV6;

            // Check if chart exists and needs updating
            if (chartRef.current && chartRef.current.chartInstance) {
               // Update the chart to ensure it's properly rendered
               chartRef.current.chartInstance.update();
            } else if (hasNoData && !this.state.loading && !this.state.noDataV5 && !this.state.noDataV6) {
               // If chart has no data, request it
               requestForData = true;
               this.getData(this.props.timespan, this.props.filter, this.props.cancelToken);
            }
         });
      }
   };
   render() {
      const { activeTab, chartV5, chartV6, modal, url, header, cancelToken } = this.state;

      // Check if active chart has no data
      const activeChartHasNoData = activeTab === '5' ? this.state.noDataV5 : this.state.noDataV6;

      // Show error or no data message for the active tab
      const showErrorMessage = this.state.error || (activeChartHasNoData && !this.state.loading);
      const issueMsg = this.state.error ? this.state.error : 'No data available';

      const { toggleShow, selectedError, timespansPerIndex, chosenIndex } = modal;
      const chosenTimespan = timespansPerIndex[chosenIndex];

      return (
         <WidgetContainer>
            <WidgetHeaderContainer>
               <HeightSetContainer $heightInPx={23}>
                  <TwoSideFlexContainer style={{ justifyContent: 'space-between' }}>
                     <SimpleFlexRow style={{ rowGap: '6px', flexWrap: 'wrap' }}>
                        <SimpleFlexItem>
                           <StyledButton
                              type='button'
                              fontSizePx={10.5}
                              className={'btn'}
                              fixMargin
                              heightPx={20}
                              widthPx={120}
                              bgColor={DefaultBlue(0.55)}
                              fontColor={'black'}
                              bgColorHover={DefaultBlue(0.4)}
                              fontColorHover={'black'}
                              border={'1px solid rgba(0,0,0,0.2)'}
                              $buttonHeightPx={19}
                           >
                              <DescriptionLink
                                 cursor='pointer'
                                 fontSizePX={10.5}
                                 marginLeftPx={0}
                                 href='https://docs.nanocosmos.de/docs/webrtc/nanostream_webrtc_api#errorcode--number'
                                 target='_blank'
                                 rel='noopener noreferrer'
                                 $color='black'
                              >
                                 View error codes
                              </DescriptionLink>
                           </StyledButton>
                        </SimpleFlexItem>
                        <HorizontalSeparator
                           color={DefaultGrey(1, 180)}
                           widthInPx={1}
                           heightInPx={18}
                           marginX_InPx={12}
                           marginTopInPx={0}
                        />
                        <SimpleFlexItem>
                           <CsvExportFromApiButton
                              url={url}
                              header={header}
                              cancelToken={cancelToken}
                              filename={'Webrtc_ErrorCodes'}
                           />
                        </SimpleFlexItem>

                        <HorizontalSeparator
                           color={DefaultGrey(1, 180)}
                           widthInPx={1}
                           heightInPx={18}
                           marginX_InPx={12}
                           marginTopInPx={0}
                        />
                        <SimpleFlexItem style={{ gap: '6px' }}>
                           <StyledButton
                              type='button'
                              fontSizePx={10.5}
                              className={'btn'}
                              fixMargin
                              marginRightPx={5}
                              heightPx={20}
                              widthPx={90}
                              bgColor={activeTab === '5' ? DefaultBlue(0.55) : DefaultGrey()}
                              onClick={() => this.toggleTab('5')}
                              fontColor={'black'}
                              bgColorHover={DefaultBlue(0.4)}
                              fontColorHover={'black'}
                              border={'1px solid rgba(0,0,0,0.2)'}
                              $buttonHeightPx={19}
                           >
                              Version 5.x
                           </StyledButton>
                           <StyledButton
                              type='button'
                              fontSizePx={10.5}
                              className={'btn'}
                              fixMargin
                              heightPx={20}
                              widthPx={90}
                              bgColor={activeTab === '6' ? DefaultBlue(0.55) : DefaultGrey()}
                              onClick={() => this.toggleTab('6')}
                              fontColor={'black'}
                              bgColorHover={DefaultBlue(0.4)}
                              fontColorHover={'black'}
                              border={'1px solid rgba(0,0,0,0.2)'}
                              $buttonHeightPx={19}
                           >
                              Version 6.x
                           </StyledButton>
                        </SimpleFlexItem>
                        <SimpleFlexItem>
                           <>
                              <AlignedIconContainer
                                 data-tooltip-id='errorCodeHint'
                                 data-tooltip-html={ReactDOMServer.renderToStaticMarkup(
                                    <>
                                       <div>Webcaster Version 5 works slightly differently</div>
                                       <div>than Version 6 and cannot be directly compared.</div>
                                       <div>For instance, error code 5002 exists in both, </div>{' '}
                                       <div>but its meaning and severity are different.</div>
                                    </>,
                                 )}
                                 className='bi bi-info-circle ml-1'
                              />
                              <ReactTooltip
                                 id='errorCodeHint'
                                 place='bottom'
                                 className='reduced-line-height bring-on-top'
                                 backgroundColor='rgba(0,0,0,0.9)'
                                 textColor='rgb(240,240,240)'
                                 style={{ textAlign: 'center' }}
                              />
                           </>
                        </SimpleFlexItem>
                     </SimpleFlexRow>
                     <SimpleFlexRow>
                        <SimpleFlexItem>
                           <ZoomHint />
                        </SimpleFlexItem>
                     </SimpleFlexRow>
                  </TwoSideFlexContainer>
               </HeightSetContainer>
            </WidgetHeaderContainer>

            <WidgetBodyContainer>
               <Row>
                  <Col>
                     <CardTitle className='mb-0'>Status/Error Codes</CardTitle>
                     <div className='small text-muted'>
                        {`${this.props.timespan.title}\u00A0\u00A0\u00A0( UTC time )`}
                     </div>
                  </Col>
               </Row>
               <ChartWrapper className='chart-wrapper' marginTopPx={20} height={this.props.height}>
                  <Spinner loading={this.state.loading} parentTopMarginPx={60}>
                     {showErrorMessage ? (
                        <CenteredMsgShowing height={this.props.height}>{issueMsg}</CenteredMsgShowing>
                     ) : (
                        <SetChartHeight height={this.props.height}>
                           {activeTab === '5' && chartV5 && (
                              <Bar
                                 ref={this.chartRefV5}
                                 data={chartV5}
                                 options={chartOptions}
                                 height={this.props.height}
                              />
                           )}
                           {activeTab === '6' && chartV6 && (
                              <Bar
                                 ref={this.chartRefV6}
                                 data={chartV6}
                                 options={chartOptions}
                                 height={this.props.height}
                              />
                           )}
                        </SetChartHeight>
                     )}
                  </Spinner>
               </ChartWrapper>
            </WidgetBodyContainer>

            {toggleShow && (
               <Modal
                  term={selectedError}
                  timespan={chosenTimespan}
                  metric={STATUS_ERROR_CODES}
                  closeModal={() => this.setState({ modal: { ...this.state.modal, toggleShow: false } })}
                  settings={WEBRTC_SETTINGS}
                  chart={modal.version === '5' ? chartV5 : chartV6} // Pass only active version data
               />
            )}
         </WidgetContainer>
      );
   }
}

Errors.propTypes = {
   filter: storePropTypes.filter,
   timespan: storePropTypes.timespan,
   cancelToken: storePropTypes.cancelToken,
   settings: storePropTypes.settings,
   setAlarm: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(Errors);
